import React from "react";
import { PuffLoading } from "../Spinner/Spinners";

export const LoginMessage = () => {
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        gap: 20,
        justifyContent: "center",
        alignItems: "center",
        fontWeight: 600,
        fontSize: "1.8rem",
      }}
    >
      <PuffLoading />
      Signing you in...
    </div>
  );
};

export const LoginError = ({ message }) => {
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        gap: 20,
        justifyContent: "center",
        alignItems: "center",
        fontWeight: 600,
        fontSize: "1.8rem",
      }}
    >
      {message}
    </div>
  );
};
